<template>
    <li
        class="pr-4 flex-col justify-start items-start gap-1 flex text-slate-800 text-lg font-medium leading-7"
    >
        <p v-if="hasEnoughProgramPoints">No additional points needed!</p>
        <div
            v-else
            class="text-slate-800 text-lg font-medium leading-7 flex gap-1"
        >
            <span v-if="!isTransfer">
                {{ user.points && $filters.formatThousand(user.points) }}
            </span>

            <div
                v-else
                v-on="isTransfer && user.points ? { click: openModal } : {}"
                class="active:outline-none focus:outline-none"
                :class="{ 'cursor-pointer': isTransfer && user.points }"
                tabindex="0"
            >
                <span>
                    {{ user.points && $filters.formatThousand(user.points) }}
                </span>
                <i
                    v-show="isTransfer && user.points"
                    class="ml-1 text-slate-500 fa-regular fa-circle-info fa-sm"
                ></i>
            </div>
            <TransferSummaryCard
                :sourcePointsProgram="sourceProgram"
                :destinationProgramName="destinationProgramName"
                :destinationProgramImage="destinationProgramImage"
                :totalUsersPoints="Number(user.points)"
                :transferTime="sourceProgram?.transferTime"
                @close="closeModal()"
                :show="show"
            />
        </div>

        <Dialog
            :open="isOpen"
            @close="setIsOpen(false)"
            as="div"
            class="relative z-40 w-screen"
        >
            <div
                class="fixed inset-0 bg-slate-800/50"
                aria-hidden="true"
            />
            <div
                class="fixed inset-0 flex w-screen items-center justify-center p-4"
            >
                <DialogPanel class="w-3/5 min-w-[800px]"></DialogPanel>
            </div>
        </Dialog>
        <UsernameIcon v-if="usersCount > 1" :user="user" />
    </li>
</template>

<script>
import { ref } from 'vue';
import { Dialog, DialogPanel } from '@headlessui/vue';
import TransferSummaryCard from '@/components/hotels/property/transfer-summary-card/transfer-summary-card.vue';
import UsernameIcon from '@/components/ui/username-icon/username-icon.vue';

export default {
    components: {
        TransferSummaryCard,
        Dialog,
        DialogPanel,
        UsernameIcon,
    },
    props: {
        hasEnoughProgramPoints: {
            type: Boolean,
            default: false,
            required: false,
        },
        isTransfer: { type: Boolean, default: false, required: false },
        destinationProgramName: { type: String, required: false },
        destinationProgramImage: { type: String, required: false },
        sourceProgram: { type: Object, required: false },
        user: { type: Object, default: () => ({}) },
        usersCount: { type: Number, required: false, default: 1 },
    },
    setup(props) {
        const isOpen = ref(false);
        const show = ref(false);

        const setIsOpen = (value) => {
            isOpen.value = value;
        };
        const openModal = () => {
            show.value = true;
        };
        const closeModal = () => {
            show.value = false;
        };
        return {
            isOpen,
            setIsOpen,
            openModal,
            closeModal,
            show,
        };
    },
};
</script>
